<template>
    <nav @keydown.esc="handleClickOutside" id="main-navigation" aria-label="Main Navigation" class="vue-navigation" v-click-outside="() => handleClickOutside()">
        <button @click="toggleMenu" id="menu-toggle" type="button" aria-controls="block-main-menu" :aria-expanded="open ? 'true' : 'false'">
            <span class="bars"></span>
            <span class="text">
                <span class="open-text">{{ 'Menu' }}</span>
                <span class="close-text">{{ 'Close' }}</span>
            </span>
        </button>

        <div class="menu-wrapper">
            <cp-navigation-list
                :items="items"
                :active-id="activeId"
                @navigation-link-clicked="handleClick"
                :depth="1"
                :open="open"
            ></cp-navigation-list>

            <mobile-active-garage-block
                :garage-entity="activeGarage"
            ></mobile-active-garage-block>
        </div>
    </nav>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
    name: "Navigation",

    directives: {
        ClickOutside
    },

    props: {
        menu: {
            type: Array,
            required: true,
        },
        activeGarage: {
            default: null
        }
    },

    data() {
        return {
            activeId: null,
            items: [],
            open: false
        }
    },

    created() {
        this.items = this.menu
    },

    methods: {
        toggleMenu() {
            this.open = !this.open

            if (this.open) {
                document.body.classList.add('main-menu-open')
                return
            }

            document.body.classList.remove('main-menu-open')
        },

        handleClick(payload) {
            this.activeId = payload.id
        },

        checkOpenValue(items) {
            items.forEach((item) => {
                item.open = _.isEqual(item.id, this.activeId) || !lodash.isNil(item.children.find((element) => _.isEqual(element.id, this.activeId)));

                if (_.isEmpty(item.children)) {
                    return
                }

                this.checkOpenValue(item.children);
            });
        },

        handleClickOutside() {
            this.handleCloseAll(this.items);
        },

        handleCloseAll(items) {
            items.forEach((item) => {
                item.open = false;

                if (_.isEmpty(item.children)) {
                    return;
                }

                this.handleCloseAll(item.children);
            })
        }
    },

    watch: {
        activeId() {
             this.checkOpenValue(this.items)
        }
    }
}
</script>